import React, { Component } from 'react'

require('./index.css')

class RxShareScreen extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      menuActive: 0,
      screenActiveId: '',
      screenSources: {
        'EntireScreen': [],
        'Application': []
      }
    }
  }

  componentDidMount() {
    let screenSources = this.state.screenSources
    
    try {
      if (window.desktopCapturer) {
        window.desktopCapturer.getSources({ types: ['window', 'screen'] }).then(async sources => {
          for (const source of sources) {
            if (source.name === 'Entire Screen') {
              screenSources['EntireScreen'].push(source)
            } else {
              screenSources['Application'].push(source)
            }
          }

          this.setState({
            screenSources: screenSources
          })

          return
        }).catch(e => {console.log(e)})
      }
    } catch(e) {}

  }

  chooseMenu(number) {
    this.setState({
      menuActive: number
    })
  }
  
  closePopupShareScreen() {
    this.setState({
      screenActiveId: ''
    }, () => {
      this.props.closePopupShareScreen()
    })
  }

  confirmPopupShareScreen() {
    this.props.confirmSourceShareScreen(this.state.screenActiveId || '')
    this.setState({
      screenActiveId: ''
    })
  }

  chooseSourceId(sourceId) {
    if (sourceId) {
      this.setState({
        screenActiveId: sourceId
      }) 
    }
  }


  render() {
    let screenSources = this.state.screenSources

    return (
      <>
        <div className='popup-sharescreen'>
          <div className='popup-sharescreen-background'></div>
          <div className='popup-sharescreen-main'>
            <div className='popup-sharescreen-center'>
              <div className='popup-sharescreen-header'>
                <div className='popup-sharescreen-header-title'>
                  Share your screen
                </div>
              </div>
              <div className='popup-sharescreen-body'>
                <div className='popup-sharescreen-menu'>
                  <span className={(this.state.menuActive === 0) ? 'sharescreen-menu-active' : ''} onClick={e => this.chooseMenu(0)}>Your Entire Sreen</span>
                  <span className={(this.state.menuActive === 1) ? 'sharescreen-menu-active' : ''} onClick={e => this.chooseMenu(1)}>Application Window</span>
                </div>
                <div className='popup-sharescreen-content'>
                  {(this.state.menuActive === 0) && <div className='popup-sharescreen-entirescreen'>
                    {(screenSources && screenSources['EntireScreen'] && screenSources['EntireScreen'].constructor === Array && screenSources['EntireScreen'].length > 0) && <img className={(this.state.screenActiveId === screenSources['EntireScreen'][0].id) ? 'source-sharescreen-active' : ''} alt='entirescreen' src={screenSources['EntireScreen'][0].thumbnail.toDataURL()} onClick={e => this.chooseSourceId(screenSources['EntireScreen'][0].id)} />}

                  </div>}  

                  {(this.state.menuActive === 1) && <div className='popup-sharescreen-application'>
                    {(screenSources && screenSources['Application'] && screenSources['Application'].constructor === Array && screenSources['Application'].length > 0) && <>
                      {screenSources['Application'].map((source, sourceIndex) => <div key={sourceIndex} className='img-sharescreen-application' onClick={e => this.chooseSourceId(source.id)} >
                        <img className={(this.state.screenActiveId === source.id) ? 'source-sharescreen-active' : ''} alt={'application'+sourceIndex} src={source.thumbnail.toDataURL()} />
                        <div>{source.name || ''}</div>
                      </div>)}
                    </> }
                  </div>}
                </div>
              </div>
              <div className='popup-sharescreen-footer'>
                <span className='popup-sharescreen-btn-cancel' onClick={e => this.closePopupShareScreen()}>
                  Cancel
                </span>
                <span className='popup-sharescreen-btn-share' onClick={e => this.confirmPopupShareScreen()}>
                  Share
                </span>
              </div>
            </div>
          </div>
        </div>

      </>
    )
  }
}


export default RxShareScreen
